import { Bell, Building2, IndianRupee, KeyRound, Landmark, ShieldCheck, Sliders, Users } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { ComponentType } from "react";
import { useState } from "react";
import { ToastProvider } from "@/components/ui/Toast";
import AdminUsersTab from "./components/AdminUsersTab";
import ApiConfigTab from "./components/ApiConfigTab";
import BillingTab from "./components/BillingTab";
import EnterpriseTab from "./components/EnterpriseTab";
import GeneralTab from "./components/GeneralTab";
//import NotificationsTab from "./components/NotificationsTab";
import SecurityTab from "./components/SecurityTab";
import RbacMatrixTab from "./components/RbacMatrixTab";

interface SettingsTab {
  key: string;
  label: string;
  icon: LucideIcon;
  component: ComponentType;
}

const TABS: SettingsTab[] = [
  { key: "general", label: "General", icon: Building2, component: GeneralTab },
  { key: "rbac", label: "Roles & Permissions", icon: Sliders, component: RbacMatrixTab },
  { key: "admins", label: "Staff Users", icon: Users, component: AdminUsersTab },
  // { key: "api", label: "API Configuration", icon: KeyRound, component: ApiConfigTab },
  { key: "enterprise", label: "Enterprise Config", icon: Landmark, component: EnterpriseTab },
  { key: "billing", label: "Billing", icon: IndianRupee, component: BillingTab },
  //{ key: "notifications", label: "Notifications", icon: Bell, component: NotificationsTab },
  { key: "security", label: "Security", icon: ShieldCheck, component: SecurityTab },
];

export default function AdminSettings() {
  const [active, setActive] = useState("general");
  const ActiveTab = TABS.find((t) => t.key === active)?.component || GeneralTab;

  return (
    <ToastProvider>
      <div className="mx-auto w-full max-w-[1440px] px-4 py-6 md:px-6">
        <div>
          <h1 className="text-2xl font-semibold text-ink">Settings</h1>
          <p className="mt-1 text-sm text-ink-secondary">Configure platform, API and notification preferences</p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-[220px_1fr]">
          {/* Vertical tab rail */}
          <div className="rounded-[10px] border border-line bg-card p-2 shadow-card">
            <nav className="flex gap-1 overflow-x-auto lg:flex-col lg:overflow-visible">
              {TABS.map((tab) => {
                const isActive = tab.key === active;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    onClick={() => setActive(tab.key)}
                    className={`flex h-11 shrink-0 items-center gap-2.5 whitespace-nowrap rounded-md px-3 text-sm transition-colors cursor-pointer ${
                      isActive
                        ? "bg-primary-50 font-medium text-primary-500"
                        : "text-ink-secondary hover:bg-page hover:text-ink"
                    }`}
                  >
                    <span className="flex h-5 w-5 items-center justify-center">
                      <tab.icon className="h-[18px] w-[18px]" />
                    </span>
                    {tab.label}
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Content panel */}
          <div className="min-w-0">
            <ActiveTab />
          </div>
        </div>
      </div>
    </ToastProvider>
  );
}